import $ from 'jquery';

import './status-messages.js';
import './detect-scroll.js';
import './detect-extinct-browsers.js';
import './menu-toggle.js';
import './language-switcher-toggle';
import './my-pages-toggle';
import './prevent-paste';
import './expandable.js';
import './open-modal.js';
import objectFitImages from 'object-fit-images';

$(() => {
  objectFitImages();
});

